import { defineComponent as _defineComponent } from 'vue'
import PrivacyPolicyCheck from '@features/privacy-policy/ui/PrivacyPolicyCheck.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'privacyPolicy',
  setup(__props) {


return { __sfc: true,PrivacyPolicyCheck }
}

})